export default __webpack_public_path__ + "static/media/OscillatorsImg.f80a5617.jpg";